import { useEffect, useRef } from 'react';

export const useWhenFontLoaded = (callback: VoidFunction): void => {
    const callbackRef = useRef(callback);

    useEffect(() => {
        void document.fonts.load('1em hh sans').then(() => {
            callbackRef.current();
        });
    }, [callbackRef]);
};
